import { render } from "./ProblemDescriptionPage.vue?vue&type=template&id=536132b7&scoped=true&ts=true"
import script from "./ProblemDescriptionPage.vue?vue&type=script&lang=ts"
export * from "./ProblemDescriptionPage.vue?vue&type=script&lang=ts"

import "./ProblemDescriptionPage.vue?vue&type=style&index=0&id=536132b7&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536132b7"]])

export default __exports__